<script setup lang="ts">
import type { ResolvedMonospaceDataSource } from '#layers/data-model/types/schema/resolved-schema';
import type { MigrationStepGroup } from '#layers/data-model/utils/migration-step-groups';
import MigrationSteps from '#layers/data-model/components/Migration/Steps.vue';

const props = defineProps<{
	source: Pick<ResolvedMonospaceDataSource, 'apiName'>;
	groups: MigrationStepGroup[];
}>();
</script>

<template>
	<DDialog
		:title="$t('pages.data_model.introspection.result.title')"
		:description="$t('pages.data_model.introspection.result.description', { source: props.source.apiName })"
		size="xl"
		:ui="{ body: 'p-0!' }"
	>
		<template #body>
			<DAnimatedSheet
				dimension="height"
				:duration="120"
				class="flex w-full flex-col gap-5 px-6 pt-4 pb-6"
				data-testid="source-introspection-result-dialog"
			>
				<MigrationSteps :groups="props.groups" />
			</DAnimatedSheet>
		</template>

		<template #footer="{ close }">
			<DButton color="neutral" @click="close">
				{{ $t('common.close') }}
			</DButton>
		</template>
	</DDialog>
</template>
